var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "items-wrapper cursor-pointer pr-2",
      class: {
        draggable: !_setup.flags?.readonly,
        selected: _setup.isSelected || _setup.isActiveEps,
        active: _setup.isActive,
        "print-area": _setup.isPrintArea,
        "product-guidelines": _setup.isProductGuidelines,
        overlay: _setup.isOverlay,
      },
      style: _setup.itemStyle,
      attrs: { "data-zIndex": _vm.item.zIndex },
      on: { click: _setup.onElementClick },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }